import useNotifications from '@/composables/useNotifications'
import { useRouter } from '@core/utils/utils'
import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import { useLambda } from '@/views/habit/awsLambda'
import { oid } from '@/helpers/mongoHelpers'
import store from '@/store'
import { hasPermission } from '@/composables/usePermission'
import useAuditLog from '@/composables/useAuditLog'

export default function useLocationEdit() {
  const { showSuccessMessage, showErrorMessage } = useNotifications()
  const { route, router } = useRouter()
  const { updateItem, getItem } = useLambda()
  const { addAuditEntry } = useAuditLog()
  const userData = store.state?.userStore?.userData
  const location = ref({})
  const originalData = ref(null)
  const isSubmitting = ref(false)
  const query = { _id: oid(route.value.params.id), client_id: oid(userData.client.$oid) }
  const collection = 'location'

  async function show() {
    isSubmitting.value = true

    try {
      const item = await getItem({ collection, query })

      // Inicializar history si no existe (documentos legacy)
      if (item && !item.history) {
        item.history = []
      }

      location.value = item || {}
      originalData.value = JSON.parse(JSON.stringify(item || {}))
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.location_fetch_error'))
    } finally {
      isSubmitting.value = false
    }
  }

  async function update(data) {
    if (!hasPermission('organization-locations', 'edit')) {
      showErrorMessage(i18n.t('message.you_are_not_authorized'))
      return
    }

    isSubmitting.value = true

    try {
      const payload = {}
      if (data.location?.value) payload.location = data.location.value
      if (data.zone?.value) payload.zone = data.zone.value
      if (data.agency?.value) payload.agency = data.agency.value

      const action = { $set: payload }

      await updateItem({ collection, query, action })

      // Registrar en logs de auditoría
      await addAuditEntry({
        collection,
        documentId: route.value.params.id,
        originalData: originalData.value,
        updatedData: { ...location.value, ...payload },
      })

      showSuccessMessage(i18n.t('message.location_updated'))
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.location_update_error'))
    } finally {
      router.push({ name: 'organization-location-list' })
      isSubmitting.value = false
    }
  }

  return {
    update,
    show,
    location,
    isSubmitting,
  }
}
